<template>
<Dialog header="Öz Değerlendirme - Doğrulama Veri Transferi" 
v-model:visible="$store.state.ui.verificationdatatransfermodal" 
:breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '75vw'}"
:modal="true"
>
<div class="grid mt-b">
<div class="col-12">
<p><b class="text-primary">{{$store.state.ui.verificationdatatransferdata.supplier.name}}</b>  {{$store.state.ui.verificationdatatransferdata.flow.project.name}} projesi öz değerlendirme işaretlemelerini, doğrulama aşamasına tranfer etmek üzeresiniz.</p>
<p>Bu işlem öz değerlendirme aşamadındaki işaretlemeleri,   doğrulama aşamasında daha önce yapılan işaretlemelerin üzere yazacaktır</p>

<h3 class="text-red-500 text-center">Devam Etmek İstiyor musunuz?</h3>


</div>
</div>

<template #footer>
<Button :label="$store.state.languages.lang_phrases.iptal" icon="pi pi-times" @click="close" class=" p-button-danger p-button-outlined  p-button-sm" />
<Button :label="$store.state.languages.lang_phrases.kaydet" icon="pi pi-times" @click="submit" :loading="submitting" class=" p-button-primary p-button-outlined  p-button-sm" />
</template>


</Dialog>
</template>

<script>
export default {

  name: 'VerificationDataTransferModal',
  data () {
    return {
    	show_modal:false,
    	submitting:false,
    }
  },
  methods:{
  	showModal()
  	{
  		this.show_modal = true
  	},
  	close()
  	{
  		this.submitting = false
  		this.$store.dispatch('ui/setVerificationDataTransferModal',false) 
  		this.$store.dispatch('ui/setVerificationDataTransferData',null) 
  	},
  	async submit()
  	{
  		
  		console.log(this.$store.state.ui.verificationdatatransferdata)
  		//return false
  		this.submitting = true
  		let data = await this.generalApiGetWithoutLoader("clone_inputs_for_verification_with_vercode/"+this.$store.state.ui.verificationdatatransferdata.uuid)
  		await this.close()
  		await setTimeout(()=>{  			
      	 this.showMessage("success","Veri Taşıma Tamamlandı")
  		},500)
  	},
  }
}
</script>

<style lang="css" scoped>
</style>